import { Component, Input } from '@angular/core';
import { PersonCertificationWrite } from 'src/app/people/models/personCertificationWrite';
import { AttributeDefinitionValueListItem } from 'src/app/shared/models/attributes/attributeDefinitionValueListItem';
import { AttributeUiType } from 'src/app/shared/models/attributes/attributeUiType';
import { EntityCredential } from 'src/app/shared/models/credential/entityCredential';
import {
  ComplexSubField,
  EvidenceValue,
  IEvidenceSnapshotModel
} from 'src/app/shared/models/credential/personScenarioEvidenceDetails';
import { evidenceType } from '../../models/credential/evidenceDefinition.model';

/** modeled off of PersonFormDetailsComponent person-form-details, but with a simpler model */
/** used in ProfileScenarioEvidenceComponent and ComplexFieldSnapshotComponent */
@Component({
  selector: 'display-data',
  templateUrl: './display-data.component.html',
  styleUrls: ['./display-data.component.scss'],
  standalone: false
})
export class DisplayDataComponent {
  @Input()
  value: EvidenceValue;

  @Input()
  dataType: AttributeUiType | evidenceType;

  /**if not set will treat as CustomField/Skill */
  @Input()
  showAllFields: boolean = false;

  asString(evidenceValue: EvidenceValue): string {
    return evidenceValue ? (evidenceValue as string) : null;
  }

  asCredential(evidenceValue: EvidenceValue): EntityCredential {
    return evidenceValue as EntityCredential;
  }

  asCertification(evidenceValue: EvidenceValue): PersonCertificationWrite {
    return evidenceValue as PersonCertificationWrite;
  }

  asComplexSubFields(evidenceValue: EvidenceValue): ComplexSubField[] {
    return evidenceValue as ComplexSubField[];
  }

  /** AttributeDefinitionValueListItem is a class, but we're not calling new AttributeDefinitionValueListItem, so be careful is any methods on this. For properties, should be fine */
  asSkillOrStar(evidenceValue: EvidenceValue): AttributeDefinitionValueListItem {
    return evidenceValue as AttributeDefinitionValueListItem;
  }
}
